import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import './HomeChallengesPreview.scss';

// import images
import download from "../../assets/Images/Challenges/download.svg"
import main from "../../assets/Images/Challenges/main.png"
import cluster from "../../assets/Images/Challenges/cluster.svg"

const TABS_DATA = [
  'Mobile Application',
  'Digital Platform',
  'Digital Operations',
  'E-commerce',
];

const CASE_STUDIES_DATA = [
  {
    id: 0,
    slug: "site-auditor-viraj-constructions",
    category: 'Site Auditor – Digital Inspection for Viraj Constructions',
    description:
      'Developed a mobile-first construction inspection platform enabling site engineers to perform digital snagging, inspection reporting, and issue tracking directly from the field. The system replaced manual paperwork with real-time reporting and centralized project visibility.',
    stats: [
      { value: '5X', label: 'Faster Site Inspections' },
      { value: '80%', label: 'Reduction in Manual Reporting' }
    ],
    imageAlt: 'Construction inspection mobile app dashboard',
    image: "https://logiqlink-backend-bucket.s3.ap-south-1.amazonaws.com/uploads/1763022387793_snagoriginal.png",
  },

  {
    id: 1,
    slug: "snag-parking-smart-platform",
    category: 'Snag Parking – Smart Parking Rental Platform',
    description:
      'Built a scalable smart parking marketplace that allows property owners to rent unused parking spaces while enabling drivers to find and book parking instantly through a mobile platform with real-time availability.',
    stats: [
      { value: '10K+', label: 'Parking Spaces Listed' },
      { value: '3X', label: 'Increase in Parking Utilization' }
    ],
    imageAlt: 'Smart parking booking mobile application',
    image: "https://logiqlink-backend-bucket.s3.ap-south-1.amazonaws.com/uploads/1763023337384_site.png",
  },

  {
    id: 2,
    slug: "seamless-inventory-management-vishwakarma",
    category: 'Seamless Inventory Management by Vishwakarma Group',
    description:
      'Engineered a centralized inventory management system to streamline stock tracking, warehouse operations, and procurement workflows across multiple locations, improving operational efficiency and reducing stock discrepancies.',
    stats: [
      { value: '40%', label: 'Reduction in Inventory Errors' },
      { value: '60%', label: 'Faster Stock Reconciliation' }
    ],
    imageAlt: 'Inventory management analytics dashboard',
    image: "https://logiqlink-backend-bucket.s3.ap-south-1.amazonaws.com/uploads/1763023488008_inventory.png",
  },

  {
    id: 3,
    slug: "brand-ecommerce-transformation-alldoer",
    category: 'Brand & Ecommerce Transformation for Alldoer',
    description:
      'Delivered a full digital commerce transformation including brand positioning, modern UI/UX redesign, and a scalable eCommerce platform that improved product discovery, checkout flow, and overall customer experience.',
    stats: [
      { value: '2.5X', label: 'Increase in Online Sales' },
      { value: '55%', label: 'Improvement in Conversion Rate' }
    ],
    imageAlt: 'Ecommerce website dashboard and product catalog',
    image: "https://logiqlink-backend-bucket.s3.ap-south-1.amazonaws.com/uploads/1763023372786_alldoer.png",
  }
];

function HomeChallengesPreview() {
  const [activeTab, setActiveTab] = useState(0);
  const navigate = useNavigate();

  const currentData = CASE_STUDIES_DATA[activeTab] || CASE_STUDIES_DATA[0];

  return (
    <section className="case-studies-section">
      {/* Background Glow */}
      <div className="cs-bg-glow" aria-hidden="true"></div>

      <div className="cs-container">

        {/* Header Section */}
        <div className="cs-header">
          <div className="cs-capsule">
            <div className="icon-wrapper">
              <div className="icon-blur" aria-hidden="true"></div>
              <img src={cluster} alt="cluster" className="cs-icon" />
            </div>
            <span>Case Studies</span>
          </div>

          <h2 className="cs-heading">
            <span className="text-white">Solving Real-World</span>
            <br />
            <span className="highlight-box">Challenges With Smart Tech</span>
          </h2>
        </div>

        {/* Interactive Case Studies Area */}
        <div className="cs-interactive-area">

          {/* Tabs */}
          <div className="cs-tabs-header">
            {TABS_DATA.map((tab, index) => (
              <button
                key={index}
                className={`cs-tab-btn ${activeTab === index ? 'active' : ''}`}
                onClick={() => setActiveTab(index)}
              >
                {tab}
              </button>
            ))}
          </div>

          {/* Content Card with Framer Motion */}
          <div className="cs-content-card">
            <AnimatePresence mode="wait">
              <motion.div
                key={activeTab}
                className="cs-card-inner"
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
                transition={{ duration: 0.3, ease: 'easeInOut' }}
              >

                {/* Left Side */}
                <div className="cs-card-content">
                  <div className="cs-text-group">
                    <h3 className="cs-category">{currentData.category}</h3>
                    <p className="cs-description">{currentData.description}</p>
                  </div>

                  <div className="cs-stats-row">
                    {currentData.stats.map((stat, idx) => (
                      <div className="cs-stat-item" key={idx}>
                        <h4>{stat.value}</h4>
                        <p>{stat.label}</p>
                      </div>
                    ))}
                  </div>

                  <div className="cs-actions">
                    <button
                      className="cs-btn-primary"
                      onClick={() => navigate(`/case-studies/${currentData?.slug}`)}
                    >
                      View Case Study
                    </button>

                    {/* <button className="cs-btn-secondary" onClick={() => navigate('/case-studies')}>
                      <img src={download} alt="download" className="btn-icon" />
                      Download Case Study
                    </button> */}
                  </div>
                </div>

                {/* Right Side Image */}
                <div className="cs-card-image-wrapper">
                  <img
                    src={`${currentData.image}`}
                    alt={currentData.imageAlt}
                    className="cs-feature-image"
                  />
                </div>

              </motion.div>
            </AnimatePresence>
          </div>

        </div>
      </div>
    </section>
  );
}

export default HomeChallengesPreview;